import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import Spinner from '../components/Widgets/Spinner';
import {  SignIn, Username, Password, CloudId, Passcode } from '../constant';

const AuthCallback = () => {
    const location = useLocation();
    const [authData, setAuthData] = useState(null);
    const [subscribers, setSubscribers] = useState([]);
    const [ssoType, setSsoType] = useState('');
    const [ssoToken, setSsoToken] = useState('');
    const [accessToken, setAccessToken] = useState(null);
    const [loading, setLoading] = useState(false);
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [cloudId, setCloudId] = useState('STRATUS_APP');
    const [passcode, setPasscode] = useState("");
    const [mfa, setMfa] = useState({});

    useEffect(() => {
        // Capture the redirect URI hash and extract parameters
        const hash = location.hash;
        if (hash) {
            const params = new URLSearchParams(hash.substring(1)); // Remove '#' and parse the parameters
            // Extract token and other details from the hash
            let accessToken = params.get("id_token");
            if(!accessToken){
                accessToken = params.get("access_token");
                ssoSignin(accessToken, 'office')
                return;
            }

            ssoSignin(accessToken, 'google')

            
        }
    }, [location]);

    const ssoSignin = async (token, type, subscriberLogin) => {
        setLoading(true);
        const creds = {
            "cloud_id": 'STRATUS_APP',
            "type": type,
            "idToken": token
        };
        if (subscriberLogin) {
            creds.subscriber_login = subscriberLogin;
        }
        axios.post(`${process.env.REACT_APP_API_URL}ssoSignin`, creds)
            .then(response => {
                setLoading(false);
                if (response.data.subscribers && response.data.subscribers.length > 0) {
                    console.log("Setting subscribers")
                    setSubscribers(response.data.subscribers)
                    setSsoType(type)
                    setSsoToken(token)
                    return;
                }
                if (response.data.mfa === "mfa_required") {
                    setUsername(response.data.username);
                    setPassword(type);
                    setMfa(response.data);
                    return

                }
                let code = "csc:" + response.data.username + ":V2=" + btoa(type) + "@" + cloudId
                if (process.env.REACT_APP_BUILD === "dev") {
                    code += "*"
                }
                window.location.href = code

                toast.success("Signing In Please Wait!");
            })
            .catch(err => {
                setLoading(false);
                toast.error("Failed to login");
                console.log(err);

            });
    }
    const handleSecondSso = (subscriberLogin) => {
        ssoSignin(ssoToken, ssoType, subscriberLogin)
    }
    const goBack = () => {
        setMfa({});
        setSubscribers([]);
    }
    const secondFactorAppLogin = () => {
        setLoading(true);
        const payLoad = {
            "cloud_id": cloudId,
            "username": username,
            "password": password,
            "passcode": passcode,
            "mfa_type": mfa.mfa_type,
            "mfa_vendor": mfa.mfa_vendor,
            "access_token": mfa.access_token,
        }
        axios.post(`${process.env.REACT_APP_API_URL}secondFactorAppSignin`, payLoad)
            .then(response => {
                setLoading(false);
                let code = "csc:" + username + ":V2=" + btoa(password) + "@" + cloudId
                if (process.env.REACT_APP_BUILD === "dev") {
                    code += "*"
                }
                window.location.href = code;
                toast.success("Signing In Please Wait!");
            })
            .catch(err => {
                setLoading(false);
                toast.error("Failed to login");
                console.log(err);

            });
    }
    return (
        <div style={{ padding: "20px" }}>
            {/* {authData ? (
                <div>
                    <h1>Redirecting with token...</h1>
                </div>
            ) : (
                <p>Processing authentication...</p>
            )} */}

            <div className="text-center">
                {loading && (
                    <Spinner />
                )}
                <h4>{SignIn}</h4>
                <h6>
                    {
                        subscribers.length > 0?
                            "Choose a Subscriber to Sign In As"
                            :
                            "Loading..."
                    }
                </h6>
            </div>
                    <div>
                        <div className="subscriber-list">
                            {
                                subscribers.map((subscriber, index) => {
                                    return (
                                        <div key={index} className="subscriber" onClick={e => handleSecondSso(subscriber.subscriber_login)} >
                                            <span>{subscriber.subscriber_login}</span>
                                        </div>
                                    )
                                })
                            }
                        </div>
                        <p className="go-back" onClick={goBack}>Go Back</p>
                    </div>      
        </div>
    );
};

export default AuthCallback;
